export default "__VITE_ASSET___R_ahbZu__"